class CTCampaignVideoHero {
  constructor(section) {
    this.section = section;
    this.video = section.querySelector(
      '.ct-campaign-video-hero__video'
    );
    this.control = section.querySelector(
      '[data-ct-video-control]'
    );
    this.pauseIcon = section.querySelector(
      '[data-ct-video-pause-icon]'
    );
    this.playIcon = section.querySelector(
      '[data-ct-video-play-icon]'
    );

    if (!this.video) return;

    this.video.muted = true;
    this.video.playsInline = true;

    this.bindEvents();
    this.handleReducedMotion();
    this.updateControl();
  }

  bindEvents() {
    this.control?.addEventListener('click', () => {
      if (this.video.paused) {
        const playPromise = this.video.play();

        if (playPromise !== undefined) {
          playPromise.catch(() => {
            this.updateControl();
          });
        }
      } else {
        this.video.pause();
      }
    });

    this.video.addEventListener('play', () => {
      this.updateControl();
    });

    this.video.addEventListener('pause', () => {
      this.updateControl();
    });

    this.video.addEventListener('ended', () => {
      this.updateControl();
    });
  }

  handleReducedMotion() {
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    if (reduceMotion.matches) {
      this.video.pause();
    }
  }

  updateControl() {
    if (!this.control) return;

    const isPaused = this.video.paused;

    this.control.setAttribute(
      'aria-label',
      isPaused ? 'Play video' : 'Pause video'
    );

    if (this.playIcon) {
      this.playIcon.hidden = !isPaused;
    }

    if (this.pauseIcon) {
      this.pauseIcon.hidden = isPaused;
    }
  }
}

function initializeCTCampaignVideoHero(root = document) {
  root
    .querySelectorAll(
      '[data-ct-video-hero]:not([data-ct-video-hero-initialized])'
    )
    .forEach((section) => {
      section.setAttribute(
        'data-ct-video-hero-initialized',
        'true'
      );

      new CTCampaignVideoHero(section);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeCTCampaignVideoHero();
});

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeCTCampaignVideoHero(event.target);
  }
);